<template>
	<div class="mine_page">
		<van-nav-bar :title="$t('q60') || 'My'" class="header_b" :border="false"></van-nav-bar>
		<div id="mine">
			<div class="profile-bg"></div>
			<div class="profile-wrapper">
				<div class="info-card">
					<div class="info-left">
						<div>
							<img src="/img/neww/userpic.png" alt="" class="avatar">
						</div>
						<div class="profile-name">
							<div>{{userInfo.username || ''}}</div>
						</div>
					</div>
					<img src="/img/mine/m_icon1.png" alt="" class="icon-setting"
						@click="$router.push({path:'/IndexInfo'})">
				</div>

				<div class="c_vip">
					<div class="ee">
						{{$t('Open an exclusive membership')}}
					</div>
					<div class="down">{{$t('Open once and the date is unlimited')}}</div>
				</div>

				<div class="menu-row" @click="doPay1">
					<div class="menu-left">
						<img src="/img/mine/m3.png" class="cl_set">
						<div class="text-k">{{ $t('Membership card')}}</div>
					</div>
					<!-- no right arrow in the screenshot, but keeping it to match old UI flow, wait, let's remove it if screenshot doesn't have it. Ah, the screenshot DOES NOT have right arrows! I will remove them to perfectly match the UI! -->
				</div>

				<div class="menu-row" @click="doPay">
					<div class="menu-left">
						<svg class="menu-icon" viewBox="0 0 24 24" fill="#e6b98a">
							<path
								d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM4 11h16v7H4v-7zm0-4h16v2H4V7zm2 6h4v1.5H6V13zm0 3h6v1.5H6v-1.5z" />
						</svg>
						<div class="text-k">{{ $t('my.recharge') || 'Recharge' }}</div>
					</div>
					<!-- no right arrow in the screenshot, but keeping it to match old UI flow, wait, let's remove it if screenshot doesn't have it. Ah, the screenshot DOES NOT have right arrows! I will remove them to perfectly match the UI! -->
				</div>

				<div class="menu-row" @click="doWithdrawal">
					<div class="menu-left">
						<svg class="menu-icon" viewBox="0 0 24 24" fill="#e6b98a">
							<path
								d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM4 11h16v7H4v-7zm0-4h16v2H4V7zm4 8.5V17H6v-2.5H4.5L7 12l2.5 2.5H8z" />
						</svg>
						<div class="text-k">{{ $t('my.withdraw') || 'Withdraw' }}</div>
					</div>
				</div>

				<div class="menu-row" @click="$router.push({path:'/GameRecord'})">
					<div class="menu-left">
						<svg class="menu-icon" viewBox="0 0 24 24" fill="#e6b98a">
							<path d="M2 4l5 6 5-8 5 8 5-6v14H2V4zm10 11.5l-3-3 1.5-1.5 1.5 1.5 3.5-3.5 1.5 1.5-5 5z" />
						</svg>
						<div class="text-k">{{ $t('my.task_order') || 'Task Orders' }}</div>
					</div>
				</div>

				<div class="menu-row" @click="$router.push({path:'/LotteryRecord'})">
					<div class="menu-left">
						<svg class="menu-icon" viewBox="0 0 24 24" fill="#e6b98a">
							<path
								d="M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4h-10.35zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
						</svg>
						<div class="text-k">{{ $t('my.lucky_order') || 'Lucky Orders' }}</div>
					</div>
				</div>

				<div class="menu-row" @click="$router.push({path:'/FundRecord'})">
					<div class="menu-left">
						<svg class="menu-icon" viewBox="0 0 24 24" fill="#e6b98a">
							<path d="M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z" />
						</svg>
						<div class="text-k">{{ $t('my.fund_record') || 'Fund Record' }}</div>
					</div>
				</div>

				<div class="menu-row" @click="$router.push({path:'/Setbank'})">
					<div class="menu-left">
						<svg class="menu-icon" viewBox="0 0 24 24" fill="#e6b98a">
							<path
								d="M15 8V6c0-1.66-1.34-3-3-3S9 4.34 9 6v2H7v10h5.35c.4-1.64 1.55-3.03 3.09-3.79V13c0-1.1.9-2 2-2 .57 0 1.11.16 1.56.43V8h-4zM10.8 6c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2v2h-2.4V6z" />
							<circle cx="18" cy="18" r="4" fill="#e6b98a" />
							<path d="M17 16h2M17 18h2M18 15v6" stroke="#101012" stroke-width="1.5" />
						</svg>
						<div class="text-k">{{ $t('my.withdraw_account') || 'Withdraw Account' }}</div>
					</div>
				</div>

				<div class="menu-row" @click="$router.push({path:'/ServiceOnline'})">
					<div class="menu-left">
						<svg class="menu-icon" viewBox="0 0 24 24" fill="#e6b98a">
							<path
								d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z" />
						</svg>
						<div class="text-k">{{ $t('my.online_service') || 'Online Service' }}</div>
					</div>
				</div>

				<div class="menu-row" @click="$router.push({path:'/Language'})">
					<div class="menu-left">
						<svg class="menu-icon" viewBox="0 0 24 24" fill="#e6b98a">
							<path
								d="M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z" />
						</svg>
						<div class="text-k">{{ $t('setting.language') || 'Language Switch' }}</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				userInfo: {},
				menu_top: 40,
				isLoading: false,
			};
		},
		methods: {
			refresh() {
				this.isLoading = true;
				setTimeout(() => {
					this.isLoading = false;
					if (localStorage.getItem('token')) {
						this.$toast(this.$t("reservation.refresh"));
					} else {
						this.$router.push({
							path: '/Login'
						})
					}
				}, 500);
			},
			exit() {
				this.$toast(this.$t("my.finish_task"));
			},
			showSetting() {
				if (localStorage.getItem('token')) {
					this.$router.push({
						path: '/Setting'
					})
				} else {
					this.$router.push({
						path: '/Login'
					})
				}
			},
			toNotice() {
				if (localStorage.getItem('token')) {
					this.$router.push({
						path: '/Notice'
					})
				} else {
					this.$router.push({
						path: '/Login'
					})
				}
			},
			onRefresh() {
				setTimeout(() => {
					this.isLoading = false;
					if (localStorage.getItem('token')) {
						this.getUserInfo();
						this.$toast(this.$t("reservation.refresh"));
					} else {
						this.$router.push({
							path: '/Login'
						})
					}
				}, 500);
			},
			doLogin() {
				if (localStorage.getItem('token')) {
					this.$router.push({
						path: '/Infomation'
					});
				} else {
					this.$router.push({
						path: '/Login'
					})
				}
			},
			doPay() {
				this.$router.push({
					name: 'Recharge',
					params: {
						'balance': this.userInfo.money
					}
				})
			},
			doPay1() {
				this.$router.push({
					name: 'MemberCard',
					params: {
						'balance': this.userInfo.money
					}
				})
			},
			doWithdrawal() {
				this.$http({
					method: 'get',
					url: 'user_get_bank'
				}).then(res => {
					if (res.data.is_bank) {
						this.$router.push("withdraw");
					} else {
						this.$router.push("Setbank");
						this.$toast.fail(this.$t("setting.set_bank"));
					}
				})
			},
			toService() {
				console.log(this.$store.getters.getBaseInfo)
				if (this.$store.getters.getBaseInfo.iskefu == 1) {
					this.$router.push("Withdraw");
				} else {
					this.$toast.fail(this.$t("setting.forbid"));
				}
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 200) {
						this.userInfo = res.data;
						console.log(this.userInfo, "this.userInfo---174");
						this.menu_top = 15;
						if (this.userInfo.status !== 1) {
							this.$toast(this.$t("video.account_out"));
							localStorage.clear()
							this.$router.push({
								path: '/Login'
							})
						}
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			},

		},
		created() {
			if (localStorage.getItem('token')) {
				this.getUserInfo();
			} else {
				this.userInfo.username = this.$t("setting.log_reg");
				this.userInfo.ip = this.$t("setting.more_service");
				this.userInfo.header_img = "img/mine/avatar.png";
			}
		}
	};
</script>

<style scoped lang="less">
	/* Reset and Base */
	.mine_page {
		background-color: #101012;
		min-height: 100vh;
		box-sizing: border-box;
	}

	.header_b {
		background-color: transparent !important;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 100;
	}

	::v-deep .van-nav-bar {
		background-color: #101012 !important;
	}

	::v-deep .van-nav-bar__title {
		color: #fff;
		font-size: 32px;
	}

	::v-deep .van-hairline--bottom::after {
		border-bottom-width: 0px;
	}

	#mine {
		padding-top: 104px;
		/* nav bar offset */
		background: #101012;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
	}

	.profile-bg {
		background: linear-gradient(90deg, #efcba7, #dcab76);
		height: 202.8px;
		position: absolute;
		width: 100%;
		z-index: 1;
	}

	.profile-wrapper {
		position: relative;
		width: 100%;
		padding-bottom: 104px;
		z-index: 2;
	}

	.info-card {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 15.6px;
		padding: 41.6px 62.4px 20.8px 41.6px;
	}

	.info-left {
		display: flex;
		align-items: center;
	}

	.avatar {
		width: 124.8px;
		height: 124.8px;
		border: 4px solid #fff;
		border-radius: 50%;
		object-fit: cover;
	}

	.profile-name {
		margin-left: 31.2px;
		color: #000;
		font-size: 36px;
		font-weight: 500;
	}

	.icon-setting {
		width: 41.6px;
		cursor: pointer;
	}

	.menu-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 31.2px 41.6px;
		color: #e6b98a;
		border-bottom: 2px solid #333;
		cursor: pointer;

		&:active {
			background-color: #1a1a1c;
		}
	}

	.menu-left {
		display: flex;
		align-items: center;
	}

	.menu-icon {
		width: 46.8px;
		height: 46.8px;
		margin-right: 20.8px;
	}

	.text-k {
		color: #e6b98a;
		font-size: 28px;
	}

	.arrow-right {
		height: 35.2px;
	}

	.mine_page .c_vip {
		margin: 2.667vw 5.333vw;
		background: url(/img/mine/user-bg.png) no-repeat 50%;
		background-size: 100% 100%;
		box-sizing: border-box;
		padding: 5.333vw 5.333vw 5.333vw 5.333vw;
		color: #e6b98a;
	}

	.mine_page .c_vip .ee {
		font-size: 3.2vw;
	}

	.mine_page .c_vip .down {
		font-size: 3.733vw;
	}

	.cl_set {
		height: 6vw;
		margin-right: 2.667vw;
	}
</style>